import { getRequest } from "../../utils/request";
import superagent from "superagent";
import Cookies from "universal-cookie";
import { base_url } from "../../utils/constants";
import { GET_ALL_RESOURCE_DATA, GET_FEATURED_RESOURCE_DATA, GET_PUBLIC_CATEGORY, GET_RESOURCE_DETAILS_DATA } from "./constants";

const cookie = new Cookies();

export const recentActivity = (type, category, resource_id) => {
  return superagent
    .post(`${base_url}admin/resource-recent-activity`)
    .set("Content-Type", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .send(JSON.stringify({ type, category, resource_id }))
    .end();
};

export const getAdminResourceDetailsAction = (id, data) => (dispatch) => {
  getRequest(`admin/admin-resource/${id}`, data, dispatch, GET_RESOURCE_DETAILS_DATA);
};

export const getResourceDetailsAction = (id, data) => (dispatch) => {
  getRequest(`resource/${id}`, data, dispatch, GET_RESOURCE_DETAILS_DATA);
};

export const getPublicResourceData = (data) => (dispatch) => {
  dispatch({
    type: GET_RESOURCE_DETAILS_DATA,
    payload: {
      data: {},
    },
  });
  getRequest("resource", data, dispatch, GET_ALL_RESOURCE_DATA);
};

export const getFeaturedResourceData = (data) => (dispatch) => {
  getRequest("feature-resource", data, dispatch, GET_FEATURED_RESOURCE_DATA);
};

export const getCategoryData = (data) => (dispatch) => {
  getRequest("category", data, dispatch, GET_PUBLIC_CATEGORY);
};
